import { TKPIs } from '../../api/APITypes';

export const MOCK_KPIS: TKPIs = [
  {
    label: 'Costumers count',
    value: 39,
  },
  {
    label: 'Invoices count',
    value: 249,
  },
  {
    label: 'Categories count',
    value: 9,
  },
  {
    label: 'Products count',
    value: 50,
  },
  {
    label: 'Total margin',
    value: 610924.22,
  },
  {
    label: 'Total revenues',
    value: 4653626.779999999,
  },
];
